<div class="tags-container">
  <input class="tags-input" type="text" class="form-control" [(ngModel)]="searchString" [ngbTypeahead]="search"
    (selectItem)="selectItem($event)" [resultFormatter]="resultFormat" [inputFormatter]="inputFormat"
    [disabled]="disabled" placeholder="Skriv namn..." />
    <div>
      @for (intressent of intressenter; track intressent) {
        <span>
          <span class="tag-item">{{intressent.fornamn}}&nbsp;{{intressent.efternamn}}&nbsp;
            @if (canRemove()) {
              <i class="far fa-times" (click)="remove(intressent)"></i>
            }
          </span>
        </span>
      }
    </div>
  </div>
